import React from "react";
import {Link, Redirect} from "react-router-dom";

import Unauthorized from "../pages/Errors/Unauthorized";
import Offlinepage from "../pages/Errors/Offlinepage";
import Error500 from "../pages/Errors/Error500";

import RedirectPage from "../pages/Authentication/RedirectPage";

import EmbedClassi from "../pages/Embed/EmbedClassi";
import EmbedLezioniGratuite from "../pages/Embed/EmbedLezioniGratuite";
import EmbedAssegnaClasse from "../pages/Embed/EmbedAssegnaClasse";

import Login from "../pages/Authentication/Login";
import Dashboard from "../pages/Dashboard/Dashboard";

import { Utils } from "custom";

import AdministratorList from "../pages/Administrator/AdministratorList";
import ExportAtom from "../pages/Export/ExportAtom";

import ConsulentList from "../pages/Consulent/ConsulentList";

import LeadList from "../pages/Lead/LeadList";
import RemarketingList from "../pages/Lead/RemarketingList";

import ModuleList from "../pages/Module/ModuleList";

import TeachearsList from "../pages/Teacher/TeachersList";

import ClientList from "../pages/Client/ClientList";
import ClientGest from "../pages/Client/ClientGest";
import ClientDetail from "../pages/Client/ClientDetail";

import CourseList from "../pages/Course/CourseList";
import CourseDetail from "../pages/Course/CourseDetail";

import SellList from "../pages/Sell/SellList";
import SellCreate from "../pages/Sell/SellCreate";
import SellGest from "../pages/Sell/SellGest";

import PaymentList from "../pages/Payment/PaymentList";

import LeadDetail from "../pages/Lead/LeadDetail";

import Available from "../pages/Available/Available";
import TooManySessionPage from "../pages/Errors/TooManySessionPage";
import Profile from "../pages/Profile/Profile";

import ClassRoomList from "../pages/ClassRoom/ClassRoomList";
import ClassRoomTableClient from "../pages/ClassRoom/ClassRoomTableClient";
import ClassRoomAvailable from "../pages/ClassRoom/ClassRoomAvailable";
import ClassRoomDetail from "../pages/ClassRoom/ClassroomEdit";
import Assistance from "../pages/Assistance/Assistance";

import ClassRoomMain from "../pages/ClassRoom/ClassRoomMain";

import ClassRoomMainInside from "../pages/ClassRoom/ClassRoomMainInside";

import ClassroomTrial from "../pages/ClassroomTrial/ClassroomTrialList";
import ClassroomEdit from "../pages/ClassRoom/ClassroomEdit";

import NetworkDash from "../pages/Network/Main";
import ClassroomIndividualList from "../pages/ClassroomIndividual/ClassroomIndividualList";
import ClassRoomIndividualMainInside from "../pages/ClassroomIndividual/ClassRoomIndividualMainInside";
import AppointmentMain from "../pages/Appointment/AppointmentMain";
import MyCertificates from "../pages/Certificate/MyCertificates";
import PendingPaymentsList from "../pages/ClassRoom/PendingPaymentsList";
import StatisticsList from "../pages/Statistics/StatisticsList";



// ⚠️ "TEACHER" e "CLIENT" qui sotto sono rimasti dal gestionale di prima: nessuna di queste pagine
// si apre piu' per loro. Il gestionale e' solo per ADMIN e CONSULENT, e chi non lo e' passa al
// portale prima di arrivare a una rotta (App.js e AuthProtected.js, regole in passaggioPortale.js).
const authProtectedRoutes = [
  { path: "/dashboard", auth: ["ADMIN", "CONSULENT"], component: Dashboard },
  { path: "/statistics", auth: ["ADMIN"], component: StatisticsList },
  { path: "/admin", auth: ["ADMIN"], component: AdministratorList },
  // Solo ADMIN: da qui esce l'anagrafica completa dei corsisti.
  { path: "/export-atom", auth: ["ADMIN"], component: ExportAtom },
  { path: "/consulent", auth: ["ADMIN"], component: ConsulentList },

  { path: "/module", auth: ["ADMIN"], component: ModuleList },

  { path: "/lead", auth: ["ADMIN", "CONSULENT"], component: LeadList },
  { path: "/remarketing", auth: ["CONSULENT"], component: RemarketingList },
  { path: "/lead/detail/:id", auth: ["ADMIN", "CONSULENT"], component: LeadDetail },

  { path: "/teachers", auth: ["ADMIN"], component: TeachearsList },
  { path: "/available", auth: ["TEACHER"], component: Available },

  { path: "/client", auth: ["ADMIN", "CONSULENT"], component: ClientList },
  { path: "/client/add", auth: ["ADMIN", "CONSULENT"], component: ClientGest },
  { path: "/client/edit/:id", auth: ["ADMIN", "CONSULENT"], component: ClientGest },
  { path: "/client/:id", auth: ["ADMIN", "CONSULENT"], component: ClientDetail },

  { path: "/course", auth: ["ADMIN", "TEACHER", "CONSULENT", "CLIENT"], component: CourseList },
  { path: "/course/:id", auth: ["ADMIN", "TEACHER", "CONSULENT", "CLIENT"], component: CourseDetail },

  { path: "/sell", auth: ["ADMIN", "CONSULENT"], component: SellList },
  { path: "/sell/:id", auth: ["ADMIN", "CONSULENT"], component: SellGest },
  { path: "/sell/create", auth: ["ADMIN", "CONSULENT"], component: SellCreate },

  { path: "/profile", auth: ["ADMIN", "TEACHER", "CONSULENT", "CLIENT"], component: Profile },
  { path: "/classroom", auth: ["ADMIN", "CONSULENT"], component: ClassRoomList },
  { path: "/classroom/individual", auth: ["ADMIN", "CONSULENT", "TEACHER"], component: ClassroomIndividualList },
  { path: "/classroom/list", auth: ["TEACHER", "CLIENT"], component: ClassRoomTableClient },
  { path: "/classroom/trial", auth: ["ADMIN", "CONSULENT", "TEACHER"], component: ClassroomTrial },
  { path: "/classroom/create", auth: ["ADMIN", "TEACHER"], component: ClassRoomDetail },
  { path: "/classroom/available", auth: ["ADMIN"], component: ClassRoomAvailable },
  { path: "/classroom/edit/:id", auth: ["ADMIN"], component: ClassroomEdit },
  { path: "/classroom/pending-payments", auth: ["ADMIN", "CONSULENT"], component: PendingPaymentsList },

  { path: "/classroom/:id", auth: ["ADMIN", "TEACHER", "CONSULENT"], component: ClassRoomMain },

  { path: "/classroom/inside/:id", auth: ["ADMIN", "TEACHER", "CONSULENT", "CLIENT"], component: ClassRoomMainInside },
  { path: "/classroom/individual/:id", auth: ["ADMIN", "TEACHER", "CONSULENT", "CLIENT"], component: ClassRoomIndividualMainInside },

  { path: "/payment", auth: ["ADMIN", "CONSULENT"], component: PaymentList },

  { path: "/network", auth: ["ADMIN", "CONSULENT", "CLIENT", "TEACHER"], component: NetworkDash },

  { path: "/appointment", auth: ["ADMIN", "CONSULENT"], component: AppointmentMain },

  { path: "/certificates", auth: ["CLIENT"], component: MyCertificates },

  {
    path: "/",
    auth: ["ADMIN", "TEACHER", "CONSULENT", "CLIENT"],
    exact: true,
    component: () => <Redirect to={"/course"} />,
  },
  { path: "/assistance", auth: ["ADMIN", "TEACHER", "CONSULENT", "CLIENT"], component: Assistance },
];

const publicRoutes = [
  { path: "/redirect", component: RedirectPage },
  // Pagine embed: vivono nell'iframe di un sistema esterno, senza header ne' sidebar.
  // La sessione arriva da un gettone monouso (?t=), non dal bootstrap: questi path sono
  // anche nella whitelist di App.js, che per loro salta il giro permission/login.
  { path: "/embed/classi", component: EmbedClassi },
  { path: "/embed/lezioni-gratuite", component: EmbedLezioniGratuite },
  { path: "/embed/assegna-classe", component: EmbedAssegnaClasse },
  { path: "/login", component: Login },
  { path: "/offline", component: Offlinepage },
  { path: "/unauthorized", component: Unauthorized },
  { path: "/server/error", component: Error500 },
  { path: "/session/error", component: TooManySessionPage }

];

export { authProtectedRoutes, publicRoutes };
